<template>
     <div class="target b-white rounded shadow-sm">
        <div class="target-title border-bottom">
            <h4 class="font-blue">Candidatos</h4>
            <span class="font-gray-dark">Selecciona un candidato para ver su información profesional</span>
        </div>
        <div class="target-downloading text-center p-1 font-gray-dark"  v-if="downloading">
             <b-spinner small label="Espere ..."></b-spinner>
             <span class="p-1">Espere un momento...</span>
        </div>
        <div class="target-body text-center">
            <img src="@/assets/banners/curses/curse-introduction.png" width="200">
            <div class="__tip p-4">
                Bienvenido a la comunidad <b>Kllaar.com</b>
                Donde tu conocimiento ayudará a cientos de estudiantes a alcanzar sus objetivos.
                Aquí podrás subir tus cursos en formato MP4. Para poder llegar a <b>más estudiantes</b>
                podrás compartir tus cursos en redes sociales, ganar <b>popularidad</b> y darte a conocer entre nuestros capacitadores.
                Gracias por unirte a <b>Kllaar.com</b>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            downloading: false,
            initialButton: false
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/jobs/pages/HomeCandidate.vue